import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, IconButton, TextField, Typography } from '@mui/material'
import { Stack, Drawer } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import React, { useEffect, useState } from 'react';
import PDFViewButton from "../FileManager/PDFViewButton";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function StudentInfoSidebar( props ) {

  const [ student, setStudent ] = useState(props.student);
  const expanded = false;

  const typographyTheme = { color: '#FFFFFF'};
  
  useEffect(() => {
    setStudent(props.student);
  }, [props])

  return (
    <Drawer
        sx={{
          width: "24vw",
          maxWidth: "425px",
          '& .MuiDrawer-paper': {
            width: "24vw",
            maxWidth: "425px",
          },
        }}
        variant="persistent"
        anchor="right"
        open={props.open}
      >
    <Box style={{ backgroundColor: '#2E2E2E', overflow:'auto', paddingBottom: 20, paddingInline: 8, marginTop: "52px", height: '100%'}}>
      <Stack justifyContent="space-between">
        <Stack>
          <Box alignSelf="flex-start">
            <IconButton aria-label='hide' onClick={props.handleClose} style={{color: '#FFFFFF'}}>
              {/* setShow(prev => !prev)}> */}
              <ArrowForwardIosIcon/>
            </IconButton>
          </Box>

          <Divider style={{backgroundColor: '#FFFFFF'}}/>

          <Stack spacing={1} sx={{my: 1, px: 2}}>
            <Typography variant='h5' style={typographyTheme} >{student.first_name + " " + student.last_name}</Typography>
            <Typography style={typographyTheme}>SD2 Semester: {student.studentRankingInfo ? student.studentRankingInfo.end_semester: ""}</Typography>
            <Typography style={typographyTheme}>Contact: 
              <a href={'mailto:'+ student.email}>
                {student.email}
              </a>
            </Typography>
          </Stack>

          <Divider style={{backgroundColor: '#FFFFFF'}}/>
          
          <Stack spacing={1} sx={{my: 1, px: 2}}>
            <Typography style={typographyTheme}>GPA: {student.studentRankingInfo ? student.studentRankingInfo.gpa : ""}</Typography>

            {/* PLACEHOLDER RESUME: TO BE HANDLED WHEN WE HAVE DOCS */}

            {student.resume === 1 ? 
              <PDFViewButton
                key={props.student.user_id}
                user_id={props.student.user_id}
                type={'resume'}
                name={'Resume'}
              />
      
            : <Typography key={student.user_id} style={typographyTheme}>No Resume Uploaded</Typography>}
            
            <Accordion style={{backgroundColor: '#474747', color: 'white'}} defaultExpanded={expanded}>
              <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
              aria-controls="panel1a-content"
              id="rankings"
              >
                <Typography>Rankings</Typography>
              </AccordionSummary>
              <AccordionDetails style={{backgroundColor: '#474747', color: 'white'}}>
                {student.studentRankingInfo ? 
                  student.studentRankingInfo.rankings.map((rank, i) => 
                  {return (
                    <Typography variant='subtitle1'>{rank.ranking}: {student.studentRankingInfo.projectInfo[i].name}</Typography>
                  )}) 
                  : 
                  ""}
              </AccordionDetails>
            </Accordion>
            
            <Accordion style={{backgroundColor: '#474747', color: 'white'}} defaultExpanded={expanded}>
              <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
              aria-controls="panel1a-content"
              id="personalStatement"
              >
                <Typography>Personal Statement</Typography>
              </AccordionSummary>
              <AccordionDetails style={{ backgroundColor: '#474747', color: 'white' }}>
                {student.studentRankingInfo ? student.studentRankingInfo.personal_statement : ""}
              </AccordionDetails>
            </Accordion>


            <Accordion style={{backgroundColor: '#474747', color: 'white'}} defaultExpanded={expanded}>
              <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
              aria-controls="panel1a-content"
              id="skills"
              >
                <Typography>Skills</Typography>
              </AccordionSummary>
              <AccordionDetails style={{ backgroundColor: '#474747', color: 'white' }}>
                {student.studentRankingInfo ? student.studentRankingInfo.skills : ""}
              </AccordionDetails>
            </Accordion>

              {/* <Link target='_blank' href={'http://'}> 
                {student.resume} 
              </Link> */}

            {/* <Typography>Personal Statement:</Typography> */}
          </Stack>
        </Stack>
        <TextField 
          position='bottom' variant='outlined' multiline minRows={6} color='primary' id='notes' label='Notes' 
          style={{marginInline: 16, backgroundColor: '#474747'}}
          inputProps={{ style: { color: "white" } }}
          />
      </Stack>
    </Box>
    </Drawer>
  )
}

export default StudentInfoSidebar;